import { drawing as d, geometry as g } from '@progress/kendo-drawing';
import { defined } from './../utils';
import { deepExtend } from './../utils/deep-extend';
import { AutoSizeableMixin } from './AutoSizeableMixin';
import { VisualBase } from './VisualBase';
/**
 * A visual element that renders a circle shape.
 * Extends VisualBase and provides functionality for creating and managing circular graphics.
 */
export class Circle extends VisualBase {
    /**
     * Creates a new Circle instance.
     * @param options Configuration options for the circle
     */
    constructor(options) {
        super(options);
        // Bind mixin methods to current instance
        this._setScale = AutoSizeableMixin._setScale.bind(this);
        this._setTranslate = AutoSizeableMixin._setTranslate.bind(this);
        this._initSize = AutoSizeableMixin._initSize.bind(this);
        this._updateSize = AutoSizeableMixin._updateSize.bind(this);
        this._initCircle();
        this._initSize();
        this._initAccessibility();
    }
    /**
     * Redraws the circle with updated options.
     * @param options New options to apply to the circle
     */
    redraw(options) {
        if (options) {
            const circleOptions = this.options;
            if (options.center) {
                deepExtend(circleOptions, {
                    center: options.center
                });
                this._center.move(circleOptions.center.x, circleOptions.center.y);
            }
            if (this._diffNumericOptions(options, ['radius'])) {
                this._circle.setRadius(circleOptions.radius);
            }
            this._updateSize(options);
            super.redraw.call(this, options);
        }
    }
    /** @hidden */
    _initCircle() {
        const options = this.options;
        let width = options.width;
        let height = options.height;
        let radius = options.radius;
        if (!defined(radius)) {
            if (!defined(width)) {
                width = height;
            }
            if (!defined(height)) {
                height = width;
            }
            options.radius = radius = Math.min(width, height) / 2;
        }
        const center = options.center || { x: radius, y: radius };
        this._center = new g.Point(center.x, center.y);
        this._circle = new g.Circle(this._center, radius);
        this.drawingElement = new d.Circle(this._circle, {
            stroke: options.stroke,
            id: options.id
        });
        this._fill();
    }
}
